module.exports = __webpack_public_path__ + "static/dot-ctr.e87e9cb1.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/network/dot-ctr.png
// module id = 243
// module chunks = 0